import { render } from "./Home.vue?vue&type=template&id=70d8b3ec"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Allgemein\\Ich\\Hobbys\\Programmieren\\Web Development\\little-projects\\vue-test-router\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__